//For Gate USERS
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";
export const Add_User = "Add_User";
export const Delete_User= "Delete_User";
export const Update_User="Update_User"
export const GET_PRODUCT_REQUEST = "GET_USERS_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_USERS_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_USERS_FAILURE";
export const Add_PRODUCT = "Add_User";
export const Delete_PRODUCT= "Delete_User";
export const Update_PRODUCT="Update_User"
